import React from 'react';
import { useState, useContext, useEffect } from "react";
import { ThemeContext } from '../../../App.js';

const stage = {
    max:100,
    min:0,
    offset:20,
    thresholds: [
        {name:"Action Needed",color:"rgb(255,255,0)",value:1000},
        {name:"Minor Flooding",color:"rgb(0,64,128)",value:2000},
        {name:"Moderate Flooding",color:"rgb(0,255,255)",value:5000},
        {name:"Major Flooding",color:"rgb(255,0,0)",value:7500}
    ]
}

export default function PrecipSummary(props) {
    const theme = useContext(ThemeContext);
    const [isOnline, setIsOnline] = useState("offline");
    const [status, setStatus] = useState("No Flooding");

    const wrapper = {
        position:'relative',
        width:300,
        height:150,
        backgroundColor:"rgb(255,255,255)",
        borderRadius:8,
        padding:4,
        boxSizing: 'border-box',
        // boxShadow: "rgba(149,157,165,0.2) 0px 8px 24px"
        boxShadow: '0 4px 8px hsla(0, 0%, 0%, 0.05)'

    }

    const activeStyle = {
        position:'absolute',
        fontSize:12,
        bottom:5,
        left:5
    }

    const dateStyle = {
        position:"absolute",
        bottom:5,
        right:5,
        fontSize:12,
        marginTop:5,
        color:'rgb(128,128,128)'
    }

    const barStyle = {
        position:'absolute',
        top:5,
        bottom:5,
        left:5
    }

    const levelStyle = {
        display:'inline',
        fontSize:21,
        fontWeight:"normal",
        color:"rgb(128,128,128)"
    }

    const levelWrapper = {
        position:'relative',
        width:'100%',
        marginTop:5,
        textAlign:"center"
    }

    const nameStyle = {
        fontSize:16,
        fontWeight:"bold"
    }

    const unitStyle = {
        display:'inline',
        fontSize:21,
        marginLeft:5,
        color:"rgb(128,128,128)"
    }

    const statusStyle = {
        display:"inline-block",
        fontSize:32,
        fontWeight:'bold',
        textAlign:'center',
        color:'rgb(0,0,0)'
    }

    const statusIconStyle = {
        display:"inline-block",
        width:24,
        height:24,
        marginRight:10,
        backgroundColor:"rgb(23, 204, 52)",
        borderRadius:4
    }

    const statusWrapper = {
        position:'relative',
        width:'100%',
        marginTop:20,
        textAlign:"center"
    }

    function findParam(name) {
        console.log("PrecipSummary:findParam");
        for (var i in props.site.readings) {
            console.log("params:",props.site.readings[i]);
            if(props.site.readings[i].type == name) {
                return props.site.readings[i];
            }
        }
        console.log("PrecipSummary:unknown type:",name);
        return null;
    }

    // Setup
    var tStatus = "Normal";
    var lastUpdate;
    var level = 0;
    var levelMM = 0;
    var param;

    console.log("PrecipSummary:site:",props.site);
    console.log("PrecipSummary:readings:",props.site.readings);

    {props.site.active ? activeStyle.color = "green" : activeStyle.color="red"}

    if(props.site.message != null) {
        param = findParam("precipIntensity");
        console.log("PrecipSummary:param:",param);

        lastUpdate = new Date(parseInt(props.site.lastUpdate)*1000).toLocaleString();
        level = (props.site.message.lufft.precip.intensity).toFixed(2);
        
        param.thresholds.forEach( threshold => {
            // console.log("M:",props.site.message.lufft.precip.abs);
            if(props.site.message.lufft.precip.intensity > threshold.value) {
                tStatus = threshold.name;
            }
        })

        console.log(props.site.msg);
        console.log("PrecipSummary:levelMM:",levelMM);
        console.log("PrecipSummary:level:",level);
        console.log(tStatus);

    } else {
        console.log("PrecipSummary:No Message");
        const msg = {};
        lastUpdate = "-/-/- -:-:-";
        level = 0;
        tStatus = "No Message";
    }

    // setStatus(tStatus);

    return (
        <div style={wrapper} id="precipSummary">
            <div style={nameStyle} id="name">{props.site.name}</div>
            <div style={activeStyle} id="active">{props.site.active ? 'Online' : 'Offline'}</div>
            <div style={dateStyle} id="lastUpdate">{lastUpdate}</div>
            <div style={statusWrapper}>
                <div style={statusIconStyle}></div>
                <div style={statusStyle}>{tStatus}</div>
            </div>
            <div style={levelWrapper}>
                <div style={levelStyle}>{level}</div>
                <div style={unitStyle}>in./hr.</div>
            </div>
            {/* <div style={statusStyle}>{tStatus}</div> */}
            {/* <BarChart style={barStyle} param={param} value={levelMM}></BarChart> */}
        </div>
    )
}